import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Graphic',
  subtitle: 'Design',
  tagline: 'Visual Storytelling That Sells',
  icon: '',
  // icon: '✏️',

  heroDesc: 'Powerful visuals that communicate your brand story, capture attention, and drive action. From logos to social media creatives, we design everything your business needs.',
  mainStat: '500+',
  mainStatLabel: 'Design projects delivered across categories',
  subStats: [{ value: '48hr', label: 'Avg Delivery Time' }, { value: '100%', label: 'Client Satisfaction' }],
  features: [
    { icon: '🏷️', title: 'Logo & Brand Identity', desc: 'Memorable logos and complete brand identity packages that stand the test of time.' },
    { icon: '📱', title: 'Social Media Graphics', desc: 'Scroll-stopping posts, stories, banners, and reels graphics for all platforms.' },
    { icon: '📄', title: 'Print Design', desc: 'Business cards, brochures, flyers, and banners designed for maximum impact.' },
    { icon: '📊', title: 'Presentation Design', desc: 'Professional PowerPoint and pitch deck designs that impress stakeholders.' },
    { icon: '📦', title: 'Packaging Design', desc: 'Product packaging that attracts buyers and communicates brand quality.' },
    { icon: '🎬', title: 'Motion Graphics', desc: 'Animated graphics and videos that bring your brand story to life.' },
  ],
  benefits: [
    { title: 'Make a Lasting Impression', desc: 'Professional visuals create an immediate positive perception of your brand.' },
    { title: 'Consistent Brand Identity', desc: 'Cohesive visual language builds recognition and trust across all touchpoints.' },
    { title: 'Increase Engagement', desc: 'High-quality graphics get significantly more likes, shares, and engagement.' },
    { title: 'Communicate More Effectively', desc: 'Great design communicates your message faster and more memorably than text.' },
  ],
  process: [
    { title: 'Creative Brief', desc: 'We gather all the details about your brand, audience, and design requirements.' },
    { title: 'Concept Development', desc: 'Initial concepts developed based on research and creative direction.' },
    { title: 'Design Creation', desc: 'Full designs created with attention to every visual detail.' },
    { title: 'Review & Feedback', desc: 'You review the designs and provide specific feedback for revisions.' },
    { title: 'Final Delivery', desc: 'Final files delivered in all required formats: PNG, SVG, PDF, and more.' },
  ],
  whyChoose: [
    { icon: '🎨', title: 'Creative Excellence', desc: 'Our designers bring genuine artistic talent and strategic thinking to every project.' },
    { icon: '⚡', title: 'Fast Turnaround', desc: 'Most design projects delivered within 24–48 hours.' },
    { icon: '🔄', title: 'Revisions Included', desc: 'Multiple revision rounds included until you are fully satisfied.' },
    { icon: '📁', title: 'All File Formats', desc: 'You receive all source files and exports in every format you could need.' },
  ],
  reviews: [
    { name: 'Riya Kapoor', role: 'Startup CEO', text: 'Our logo and brand identity by DMS is stunning. Every client comments on how professional we look.' },
    { name: 'Tarun Mehta', role: 'Food Brand', text: 'The packaging design they created for our products has significantly boosted shelf appeal.' },
    { name: 'Swati Jain', role: 'Lifestyle Coach', text: 'My social media graphics are now consistently beautiful and on-brand. Love DMS design work!' },
  ],
  faq: [
    { q: 'How many revisions are included?', a: 'We include 3 rounds of revisions with all design packages. Additional revisions available at nominal cost.' },
    { q: 'What file formats will I receive?', a: 'You receive all relevant formats: AI, PSD, PDF, PNG, SVG, JPG — whatever you need.' },
    { q: 'Can you match our existing brand guidelines?', a: 'Absolutely! We strictly follow your brand guidelines to ensure complete consistency.' },
  ],
};

export default function GraphicDesign() {
  return <ServiceTemplate data={data} />;
}
